import React from "react";
import "./JobProfile.css";
import Pagination from "../Pagination/Pagination";
import SingleProfile from "./SingleProfile/SingleProfile";
import CreateModal from "./CreateJobProfile/createJobProfile";
import add from "../../Assets/icons/1.5x/Addhdpi.png";
import sort from "../../Assets/icons/1x/sortmdpi.png";
import search from "../../Assets/icons/0.75x/searchldpi.png";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import Loader from "react-loader-advanced";
import Spinner from "react-bootstrap/Spinner";
import SweetAlert from "../commonComponents/SweetAlert";
import NoDataErrorScreen from "../commonComponents/NoDataErrorScreen";
import ServerErrorScreen from "../commonComponents/ServerErrorScreen";
import ViewJobProfile from "./ViewJobProfile/ViewJobProfile";
import ConfirmSweetAlert from "../commonComponents/ConfirmSweetAlert";
import loading from "../../Assets/Images/loader-green.gif";
import { Col, Row, Form, Button } from "react-bootstrap";

class JobProfile extends React.Component {
  state = {
    modalShow: false,
    viewModalShow: false,
    currentPage: 1,
    id: "",
    sweetAlertModal: false,
    createsweetAlertModal: false,
    confirmsweetAlertModal: false,
    archivesweetAlertModal: false,
    noResults: false,
  };

  sweetAlertModalHandler = (boolean) => {
    this.setState({ sweetAlertModal: boolean });
  };
  confirmsweetAlertModalHandler = (boolean) => {
    this.setState({ confirmsweetAlertModal: boolean });
  };
  createsweetAlertModalHandler = (boolean) => {
    this.setState({ createsweetAlertModal: boolean });
  };
  archivesweetAlertModalHandler = (boolean) => {
    this.setState({ archivesweetAlertModal: boolean });
  };
  setModalShow = (boolean) => {
    this.setState({ modalShow: boolean });
  };
  setModalShow1 = (boolean) => {
    this.setState({ modalShow: boolean });
    this.create.blur();
  };
  setViewJobModalShow = () => {
    this.setState({ viewModalShow: !this.state.viewModalShow });
  };

  onPageChange = (id) => {
    this.setState(
      {
        currentPage: id,
      },
      () => {
        if (this.searchField.value !== "") {
          this.props.searchJobProfile(
            this.searchField.value.split(","),
            this.state.currentPage
          );
        } else {
          this.props.viewJobProfile(this.state.currentPage);
        }
      }
    );
  };
  onLeftChange = () => {
    if (this.state.currentPage === 1) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      () => {
        if (this.searchField.value !== "") {
          this.props.searchJobProfile(
            this.searchField.value.split(","),
            this.state.currentPage
          );
        } else {
          this.props.viewJobProfile(this.state.currentPage);
        }
      }
    );
  };
  onRightChange = () => {
    if (this.props.records === this.state.currentPage) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      () => {
        if (this.searchField.value !== "") {
          this.props.searchJobProfile(
            this.searchField.value.split(","),
            this.state.currentPage
          );
        } else {
          this.props.viewJobProfile(this.state.currentPage);
        }
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      noResults: nextProps.searchNoResults,
    });
  }

  confirmAction = () => {
    if (this.props.jobProfileDetails.length === 1) {
      this.setState({
        currentPage: this.state.currentPage - 1,
      });
    }
    this.props.archiveJobProfile(
      this.state.id,
      this.props.jobProfileDetails.length === 1
        ? this.state.currentPage - 1
        : this.state.currentPage
    );
    this.confirmsweetAlertModalHandler(false);
    this.archivesweetAlertModalHandler(true);
  };
  confirmActionId = (id) => {
    this.setState({ id: id, archivesweetAlertModal: false });
  };

  componentDidMount() {
    this.props.viewJobProfile(this.state.currentPage);
    this.setState({
      noResults: false,
    });
    this.props.getSkillsList();
  }

  searchHandler = () => {
    const newarr = this.searchField.value;
    const arr = newarr.split(",");
    this.state.currentPage = 1;
    this.props.searchJobProfile(arr, this.state.currentPage);
  };
  searchHandler2 = (e) => {
    e.preventDefault();
    if (e.keyCode == 13) {
      const newarr = this.searchField.value;
      const arr = newarr.split(",");
      this.state.currentPage = 1;
      this.props.searchJobProfile(arr, this.state.currentPage);
    }
  };

  createJobProfilesetPage = (data, page) => {
    this.state.currentPage = 1;
    this.props.createJobProfile(data, page);
    this.searchField.value = "";
  };
  render() {
    return (
      <>
        <div className="main-body-job">
          <div className="heading">
            <h3>My Profile</h3>
          </div>

          <br></br>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <input
                  ref={(element) => (this.searchField = element)}
                  onKeyUp={(e) => this.searchHandler2(e)}
                  type="text"
                  placeholder="Search by Title or Skills"
                  className="form-control shadow-none"
                  id="usr"
                />
              </div>
            </div>
            <div className="col-md-2">
              <button
                onClick={() => this.searchHandler()}
                type="button"
                className="btn btn-warning jobSearchButton"
              >
                <img
                  type="image/svg+xml"
                  src={search}
                  style={{ width: "25px", color: "white" }}
                  alt="img"
                />
              </button>
            </div>
            <div className="col-md-2">
              <button
                onClick={(e) => {
                  this.setModalShow1(true);
                }}
                ref={(el) => (this.create = el)}
                type="button"
                style={{
                  color: "white",
                  width: "150px",
                  fontWeight: "600",
                  borderRadius: "20px",
                  letterSpacing: "1.5px",
                }}
                className="btn btn-warning"
              >
                <img
                  type="image/svg+xml"
                  src={add}
                  style={{ width: "25px", marginRight: "10px" }}
                  alt="img"
                />{" "}
                Create
              </button>
            </div>
            {/* <div className='col-md-2' style={{paddingLeft:"6%"}}>
                    <img type="image/svg+xml" src={sort} style={{width:"30px",marginTop:"6%",cursor:"pointer"}}/>
                    </div> */}
          </div>

          {!this.props.serverErrorStatus ? (
            this.props.jobProfileDetails !== undefined &&
            this.props.noDataStatus == false ? (
              <div>
                <Loader
                  show={this.props.loader}
                  message={<img src={loading} />}
                  style={{ height: "auto" }}
                  foregroundStyle={{ color: "#00a99d" }}
                  backgroundStyle={{ backgroundColor: "#F3EFEF" }}
                >
                  <Row>
                    <Col md={12}  className="table-responsive"
                        style={{ height: "65vh" }}>

                        <table
                         className="jobprofileTbl"
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: "0px 0px",
                            
                          }}
                        >
                          <thead>
                            <tr>
                              <th>Title</th>
                              <th>Experience</th>
                              <th>Skills</th>
                              <th>
                                Date of <br/>
                                Posting
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <SingleProfile
                            onHideViewJob={this.setViewJobModalShow}
                            updateJobProfile={this.props.updateJobProfile}
                            confirmActionId={this.confirmActionId}
                            jobProfileDetails={this.props.jobProfileDetails}
                            page={this.state.currentPage}
                            createsweetAlertModalHandler={
                              this.createsweetAlertModalHandler
                            }
                            confirmsweetAlertModalHandler={
                              this.confirmsweetAlertModalHandler
                            }
                          />
                        </table>
                  
                    </Col>
                  </Row>
                  {this.props.records > 1 ? (
                    <Pagination
                      style={{ bottom: -70 }}
                      activePage={this.state.currentPage}
                      pageRangeDisplayed={this.props.records}
                      onPageChange={this.onPageChange}
                      onLeftChange={this.onLeftChange}
                      onRightChange={this.onRightChange}
                    />
                  ) : null}
                </Loader>
              </div>
            ) : this.state.noResults ? (
              <NoDataErrorScreen msg="No results found" />
            ) : (
              <NoDataErrorScreen msg="No Profile at this moment." />
            )
          ) : (
            <ServerErrorScreen />
          )}
        </div>
        <CreateModal
          createJobProfile={this.createJobProfilesetPage}
          show={this.state.modalShow}
          onHide={() => this.setModalShow(false)}
          sweetAlertModalHandler={this.sweetAlertModalHandler}
          page={this.state.currentPage}
        />
        {/* <ViewJobProfile
                createJobProfile={this.props.createJobProfile}
                show={this.state.viewModalShow}
                // onHideViewJob={this.setViewJobModalShow}
            />
      */}
        {this.state.sweetAlertModal ? (
          this.props.createErrorStatus ? (
            <SweetAlert
              type="danger"
              msg="Unable to create Profile. Try again"
              show="true"
            />
          ) : (
            <SweetAlert
              type="success"
              msg="Profile created successfully!"
              show="true"
            />
          )
        ) : null}
        {this.state.createsweetAlertModal ? (
          this.props.updateErrorStatus ? (
            <SweetAlert
              type="danger"
              msg="Unable to edit Profile. Try again"
              show="true"
            />
          ) : (
            <SweetAlert
              type="success"
              msg="Profile updated successfully!"
              show="true"
            />
          )
        ) : null}
        {this.state.archivesweetAlertModal ? (
          this.props.archiveErrorStatus ? (
            <SweetAlert
              type="danger"
              msg="Unable to delete profile. Try again"
              show="true"
            />
          ) : (
            <SweetAlert
              type="success"
              msg="Profile deleted successfully!"
              show="true"
            />
          )
        ) : null}
        {this.state.confirmsweetAlertModal ? (
          <ConfirmSweetAlert
            msg="Are you sure you want to delete this profile?"
            msg2="You can't undo this action."
            nextAction={this.confirmAction}
            cancelHandler={() =>
              this.setState({ confirmsweetAlertModal: false })
            }
            show="true"
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.employeeReducer.loader,
    jobProfileDetails: state.employeeReducer.jobProfileDetails,
    records: state.employeeReducer.records,
    skillLoader: state.employeeReducer.skillLoader,
    serverErrorStatus: state.employeeReducer.serverErrorStatus,
    createErrorStatus: state.employeeReducer.createErrorStatus,
    updateErrorStatus: state.employeeReducer.updateErrorStatus,
    archiveErrorStatus: state.employeeReducer.archiveErrorStatus,
    noDataStatus: state.employeeReducer.noDataStatus,
    searchNoResults: state.employeeReducer.searchNoResults,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    viewJobProfile: (page) => dispatch(actionTypes.viewJobProfile(page)),
    archiveJobProfile: (id, page) =>
      dispatch(actionTypes.archiveJobProfile(id, page)),
    createJobProfile: (data, page) =>
      dispatch(actionTypes.createJobProfile(data, 1)),
    searchJobProfile: (arr, page) =>
      dispatch(actionTypes.searchJobProfile(arr, page)),
    getSkillsList: () => dispatch(actionTypes.getSkillsMaster()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(JobProfile);
